export const setWidgets = (payload) => ({
    type: "SET_WIDGETS",
    payload
});